import React from 'react'
import AddImage2 from "../../../../../../../assets/screen/scees4.jpg";

function SBseries() {

    return (
        <div>
            <img className=' item-center flex justify-center mx-auto' src={AddImage2}></img>
        </div>
    )
}

export default SBseries
